/**
 * Skill 预览浮窗定位坐标
 */
export interface ISkillPreviewPosition {
  /** 距视口顶部距离 */
  top: number;
  /** 距视口左侧距离 */
  left: number;
  /** 预览浮窗高度（与列表下拉对齐时取锚点高度） */
  height: number;
}

/**
 * 预览浮窗默认尺寸（Figma: 480×430）
 */
export const SKILL_PREVIEW_DEFAULT_WIDTH = 480;
export const SKILL_PREVIEW_DEFAULT_HEIGHT = 430;
export const SKILL_PREVIEW_GAP = 4;

export type TSkillPreviewPlacement = 'auto' | 'right' | 'left';

/**
 * 计算 Skill 预览浮窗定位（默认锚点右侧，空间不足时翻转到左侧）
 * @param anchorRect - 锚点元素视口矩形
 * @param options.matchAnchorHeight - 是否将预览高度与锚点（如 Skill 列表下拉）保持一致
 * @param options.placement - `right`/`left` 固定侧；`auto` 优先右侧，不足时翻左侧
 */
export const calcSkillPreviewPosition = (
  anchorRect: DOMRect,
  options?: { matchAnchorHeight?: boolean; placement?: TSkillPreviewPlacement; },
): ISkillPreviewPosition => {
  const previewWidth = SKILL_PREVIEW_DEFAULT_WIDTH;
  const previewHeight = options?.matchAnchorHeight && anchorRect.height > 0
    ? Math.round(anchorRect.height)
    : SKILL_PREVIEW_DEFAULT_HEIGHT;
  const previewGap = SKILL_PREVIEW_GAP;
  const placement = options?.placement ?? 'auto';
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  let left: number;
  if (placement === 'left') {
    left = anchorRect.left - previewWidth - previewGap;
    if (left < previewGap) {
      left = previewGap;
    }
    left = Math.min(left, viewportWidth - previewWidth - previewGap);
  } else if (placement === 'right') {
    left = anchorRect.right + previewGap;
    if (left + previewWidth > viewportWidth - previewGap) {
      left = viewportWidth - previewWidth - previewGap;
    }
    left = Math.max(previewGap, left);
  } else {
    left = anchorRect.right + previewGap;
    if (left + previewWidth > viewportWidth - previewGap) {
      left = anchorRect.left - previewWidth - previewGap;
    }
    left = Math.max(
      previewGap,
      Math.min(left, viewportWidth - previewWidth - previewGap),
    );
  }

  let top = anchorRect.top;
  top = Math.max(
    previewGap,
    Math.min(top, viewportHeight - previewHeight - previewGap),
  );

  return { top, left, height: previewHeight };
};
